module.exports = __webpack_public_path__ + "img/timeline.5ca1c4a2.svg";